var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#EA5455"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4993 10.1663H20.166V9.33301C20.166 7.91634 19.0827 6.83301 17.666 6.83301H14.3327C12.916 6.83301 11.8327 7.91634 11.8327 9.33301V10.1663H8.49935C7.99935 10.1663 7.66602 10.4997 7.66602 10.9997C7.66602 11.4997 7.99935 11.833 8.49935 11.833H9.33268V22.6663C9.33268 24.083 10.416 25.1663 11.8327 25.1663H20.166C21.5827 25.1663 22.666 24.083 22.666 22.6663V11.833H23.4993C23.9993 11.833 24.3327 11.4997 24.3327 10.9997C24.3327 10.4997 23.9993 10.1663 23.4993 10.1663ZM13.4993 9.33301C13.4993 8.83301 13.8327 8.49967 14.3327 8.49967H17.666C18.166 8.49967 18.4993 8.83301 18.4993 9.33301V10.1663H13.4993V9.33301ZM20.166 23.4997C20.666 23.4997 20.9993 23.1663 20.9993 22.6663V11.833H10.9993V22.6663C10.9993 23.1663 11.3327 23.4997 11.8327 23.4997H20.166ZM15.166 15.1663V20.1663C15.166 20.6663 14.8327 20.9997 14.3327 20.9997C13.8327 20.9997 13.4993 20.6663 13.4993 20.1663V15.1663C13.4993 14.6663 13.8327 14.333 14.3327 14.333C14.8327 14.333 15.166 14.6663 15.166 15.1663ZM18.4993 20.1663V15.1663C18.4993 14.6663 18.166 14.333 17.666 14.333C17.166 14.333 16.8327 14.6663 16.8327 15.1663V20.1663C16.8327 20.6663 17.166 20.9997 17.666 20.9997C18.166 20.9997 18.4993 20.6663 18.4993 20.1663Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashRed);
export default __webpack_public_path__ + "static/media/trashRed.3c03ae875b60fc14ffc7162320034191.svg";
export { ForwardRef as ReactComponent };